var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 2.75H6.09961C6.89526 2.75 7.65832 3.06607 8.22093 3.62868C8.78354 4.19129 9.09961 4.95435 9.09961 5.75V16.25C9.09961 15.6533 8.86256 15.081 8.4406 14.659C8.01864 14.2371 7.44635 14 6.84961 14H1.59961V2.75Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 2.75H12.0996C11.304 2.75 10.5409 3.06607 9.97829 3.62868C9.41568 4.19129 9.09961 4.95435 9.09961 5.75V16.25C9.09961 15.6533 9.33666 15.081 9.75862 14.659C10.1806 14.2371 10.7529 14 11.3496 14H16.5996V2.75Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon02);
export default __webpack_public_path__ + "static/media/lesson-icon-02.f15db54340c72bf4ed02ec53b0ea090c.svg";
export { ForwardRef as ReactComponent };